<template>
  <mp-pseudo-box
    role="group"
    display="flex"
    border-radius="sm"
    padding="2"
    min-height="20"
    transition="all .2s ease"
    :_hover="{
      backgroundColor: 'ice.50',
      color: 'blue.400',
      cursor: 'pointer',
    }"
    @click="$emit('click')"
  >
    <!-- eslint-disable vue/attribute-hyphenation -->
    <mp-flex gap="4" w="full">
      <mp-box>
        <mp-box
          border="1px"
          border-color="gray.50"
          border-radius="md"
          padding="2"
          :_groupHover="{
            backgroundColor: 'white',
          }"
        >
          <mp-icon :name="icon" />
        </mp-box>
      </mp-box>
      <mp-flex flex-direction="column" flex="1">
        <mp-text
          font-size="md"
          font-weight="semibold"
          :_groupHover="{
            color: 'blue.400',
          }"
        >
          {{ title }}
        </mp-text>
        <mp-text font-size="sm" color="gray.600">
          {{ description }}
        </mp-text>
      </mp-flex>
      <mp-icon
        name="newtab"
        size="sm"
        w="4"
        h="4"
        p="1px"
        ml="auto"
        :_groupHover="{
          color: 'blue.700',
        }"
      />
    </mp-flex>
    <!-- eslint-enable -->
  </mp-pseudo-box>
</template>

<script>
export default {
  name: 'SwitchAppItem',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    icon: { type: String, default: '' },
  },
};
</script>
